<template>
  <base-layout toolbarActive toolbarClass="v-toolbar--border">
    <template #toolbarBase>
      <navigation-statistic
        @createTemplate="editTemplateDialog(filterTemp)"
        v-if="$vuetify.breakpoint.smAndUp"
      ></navigation-statistic>
      <div v-if="$vuetify.breakpoint.xsOnly" class="display-1 font-weight-bold">
        Статистика
      </div>
    </template>

    <v-container v-if="$vuetify.breakpoint.smAndUp" fluid pt-4>
      <!-- контент -->
      <router-view
        @setFilter="setFilter"
        @editTemplateDialog="editTemplateDialog"
        @editSmsDialog="editSmsDialog"
      />
    </v-container>

    <section-not-for-phone
      v-if="$vuetify.breakpoint.xsOnly"
    ></section-not-for-phone>
  </base-layout>
</template>

<script>
import BaseLayout from "../components/layout/BaseLayout.vue";
import NavigationStatistic from "../components/navigation/NavigationStatistics.vue";
import SectionNotForPhone from "../components/common/SectionNotForPhone.vue";

export default {
  name: "StatisticsView",

  components: {
    SectionNotForPhone,
    NavigationStatistic,
    BaseLayout
  },
  data: () => ({
    // для отслеживания фильтров статистики
    filterTemp: {}
  }),

  methods: {
    /**
     * Получаем из статистики текущие фильтры и запоминаем название статистики
     */
    setFilter(params) {
      if (!params.id)
        this.filterTemp = {
          template: { params: { ...params, type: this.$route.name }, name: "" }
        };
      else this.filterTemp = { template: { ...params } };
    },
    /**
     * Диологовое окно создания/редактирования шаблона
     */
    editTemplateDialog(params) {
      this.$emit("openDialog", {
        component: "templatesStatisticsEdit",
        param: params
      });
    },
    // диологовое окно редактирования смс
    editSmsDialog(params) {
      this.$emit("openDialog", {
        component: "smsMailingForm",
        param: params
      });
    }
  }
};
</script>
